import { Application } from '@/types/application';
import { Detail } from '@/types/detail';
import { Configuration, Metadata } from '@/types/metadata/metadata';
import { ValidationError, ValidationObject } from '@/types/validation';
import { isObject, isString } from '@/util/typeGuards';

export const synceventUtil = (): ValidationObject<string | undefined> => {
  const validate = (
    application: Application,
    metadata: Metadata,
    linkedSubroutineId: number,
    nodeId: number,
    blockName: string,
    configuration: Configuration,
    details: Detail
  ): ValidationError[] => {
    const errors: ValidationError[] = [];
    const value = getValue(configuration, details);
    if (configuration.required && value === undefined) {
      errors.push({
        severity: 'error',
        message: `Block ${blockName} is missing required Sync event reference: ${configuration.label}`,
        id: nodeId
      });
    } else if (value !== undefined) {
      const foundSyncEvent = application.syncevents?.find((syncevent) => syncevent.name === value);
      if (!foundSyncEvent) {
        errors.push({
          severity: 'error',
          message: `Block ${blockName} refers to a Sync event that doesn't exist.`,
          id: nodeId
        });
      }
    }
    return errors;
  };

  const getValue = (configuration: Configuration, obj: unknown): string | undefined => {
    if (!obj) return;
    const initVal = obj;
    if (isString(initVal)) {
      return initVal as string;
    } else if (isObject(obj)) {
      const prop = obj[configuration.value];
      return getValue(configuration, prop);
    }
    return;
  };

  return {
    validate: validate,
    getValue: getValue
  };
};
